<h4 class="mb-3 display-4">{{ 'carrier' | translate }}</h4>

<hr class="mb-3" />

<div class="row row-cols-2 row-cols-md-4 g-3">
  <div *ngFor="let i of sortCarrier(device_items)" class="col">
    <div
      as-button
      class="card overflow-auto h-100"
      [ngClass]="{ 'p-2': i.carrier.admin }"
      [class.active-card]="i.carrier.id === selected_carrier_id"
      [class.elevate]="i.carrier.id !== selected_carrier_id"
      [attr.aria-label]="i.carrier.name"
      (click)="selectCarrier(i)"
    >
      <div class="card-body p-4 d-flex justify-content-center">
        <img class="carrier-img img-fluid" src="{{ i.carrier.image_url }}" [alt]="i.carrier.name" />
      </div>

      <ts-admin-override-badge *ngIf="i.carrier.admin" class="position-absolute bottom-0 end-0" />
    </div>
  </div>
</div>
